import type { CMSAssetItem, CMSAssetSidebarItem } from '../types';
import type { IconProps, ColorPalette } from '@workramp/ui';

const { APP_CONSTANTS } = window;

const isImage = (assetType: string) => {
  const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'svg'];
  return imageTypes.includes(assetType);
};

export const getIconPropsForCMSAsset = (asset: CMSAssetSidebarItem | CMSAssetItem, colors: ColorPalette): IconProps => {
  if (asset.assetType === APP_CONSTANTS.CMS_ASSET_TYPES.LINK) {
    return {
      name: 'link:regular',
      color: colors.decorative.neutral[900],
    };
  }

  if (asset.assetType === APP_CONSTANTS.CMS_ASSET_TYPES.FILE && isImage(asset.fileType)) {
    return {
      name: 'image:regular',
      color: colors.decorative.neutral[900],
    };
  }

  if (asset.assetType === APP_CONSTANTS.CMS_ASSET_TYPES.FILE && asset.fileType === 'zip') {
    return {
      name: 'file-zip:regular',
      color: colors.decorative.neutral[900],
    };
  }

  return {
    name: 'file-document:regular',
    color: colors.decorative.neutral[900],
  };
};
